import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from "@mui/material";
import { useGetRatingSpreadQuery } from "../redux/service/modules/dashboard";
import Loader from "../components/common/loader";
import NoDataAvailable from "../components/common/NoDataAvailable";
import { useResponsiveStyles } from "../styles/useResponsiveStyles";

const headerLabels = [
    { id: "index", label: "" },
    { id: "no_of_stocks", label: "No.of\nStocks" },
    { id: "ff_mcap_percentage", label: "FF Mcap\n(%)" },
    { id: "mdvt_3m_percentage", label: "MDTV-3M\n(%)" },
    { id: "mf", label: "MF\n(%)" },
];

export const RatingSpread = () => {
    const { data: marketData, isLoading, error } = useGetRatingSpreadQuery();
    const { getFontSize } = useResponsiveStyles();
    let staticContent;
    if (isLoading) {
        staticContent = <Loader />;
    } else if (error) {
        staticContent = "Error";
    } else if (marketData?.length === 0) {
        staticContent = <NoDataAvailable />;
    }
    return (
        <>
            {staticContent ? (
                <div style={styles.staticContent}>{staticContent}</div>
            ) : (
                <TableContainer
                    component={Paper}
                    elevation={0}
                    sx={{
                        border: "1px solid #e5e7eb",
                        borderRadius: 2,
                        overflow: "hidden",
                    }}
                >
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: "#FFF9F9" }}>
                                {" "}
                                {/* Header Row */}
                                {headerLabels.map((header, index) => (
                                    <TableCell
                                        key={header.id}
                                        align={
                                            header.id === "index"
                                                ? "left"
                                                : "center"
                                        }
                                        sx={{
                                            py: 1,
                                            px: 2,
                                            borderBottom: "1px solid #e5e7eb",
                                            whiteSpace: "pre-line",
                                            backgroundColor:
                                                index === 0
                                                    ? "#FFF9F9"
                                                    : "inherit", // First column
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                ...getFontSize("sub-heading"),
                                                fontWeight: 800,
                                                color: "#ef4444",
                                                textAlign:
                                                    header.id === "index"
                                                        ? "left"
                                                        : "center",
                                                lineHeight: 1.2,
                                            }}
                                        >
                                            {header.label}
                                        </Typography>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {marketData?.map((row) => (
                                <TableRow
                                    key={row.index}
                                    sx={{
                                        "&:last-child td": { borderBottom: 0 },
                                        "&:hover": {
                                            backgroundColor: "#f9fafb",
                                        },
                                    }}
                                >
                                    {/* First Column with Background Color */}
                                    <TableCell
                                        sx={{
                                            py: 1,
                                            px: 2,
                                            borderBottom: "1px solid #e5e7eb",
                                            backgroundColor: "#FFF9F9", // First column background
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                // fontSize: "1rem",
                                                ...getFontSize("sub-heading"),
                                                fontWeight: 800,
                                                color: "#ef4444",
                                            }}
                                        >
                                            {row.index}
                                        </Typography>
                                    </TableCell>
                                    {/* Remaining Columns */}
                                    <TableCell
                                        align="center"
                                        sx={{
                                            py: 1.5,
                                            px: 3,
                                            borderBottom: "1px solid #e5e7eb",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                ...getFontSize("body1"),
                                                fontWeight: 500,
                                                color: "#111827",
                                            }}
                                        >
                                            {row.no_of_stocks}
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        sx={{
                                            py: 1.5,
                                            px: 3,
                                            borderBottom: "1px solid #e5e7eb",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                ...getFontSize("body1"),
                                                fontWeight: 500,
                                                color: "#111827",
                                            }}
                                        >
                                            {row.ff_mcap_percentage}
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        sx={{
                                            py: 1.5,
                                            px: 3,
                                            borderBottom: "1px solid #e5e7eb",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                ...getFontSize("body1"),
                                                fontWeight: 500,
                                                color: "#111827",
                                            }}
                                        >
                                            {row.mdvt_3m_percentage}
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        sx={{
                                            py: 1.5,
                                            px: 3,
                                            borderBottom: "1px solid #e5e7eb",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                ...getFontSize("body1"),
                                                fontWeight: 500,
                                                color: "#111827",
                                            }}
                                        >
                                            {row.mf}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </>
    );
};

const styles = {
    staticContent: {
        height: "80%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
};
